export default function enumToString(str: string): string {
  const words = str?.replaceAll('_', ' ').split(' ')

  const capitalizedWords = words.map((word) => {
    if (word.length > 0) {
      if (word.toLowerCase().includes('otp')) return 'OTP'
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    } else {
      return ''
    }
  })

  return capitalizedWords.join(' ')
}
